import React, { useEffect, useState } from 'react';
import {
  Box,
  Card,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
} from '@mui/material';
import { ChevronLeft, ChevronRight } from '@mui/icons-material';
import BASEURL from '../../Utils/Baseurl';
import request from 'graphql-request';
import MaterialTypography from '../../../components/MaterialTypography';
import { useLocation } from 'react-router-dom';

const TaskProgress = () => {
  const TaskProgressQuery = `
query allProgressUpdates($id:Int,$status:String) { 
  allProgressUpdates (userId:$id,workStatus:$status){ 
    success 
    error 
    message 
    data { 
      id 
      task { 
        id 
        title 
        assignedTo{ 
          id 
          firstName 
          lastName 
          username 
        } 
      } 
      status 
      workCompleted 
      totalHoursSpent 
      hoursWorked 
      createdAt 
      isReviewed 
      remainingTime 
    } 
  } 
}
  `;
  const params = useLocation();
  const ID = params.search.slice(1);
  const userRole = localStorage.getItem("userRole");  
  const [rows, setRows] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  useEffect(() => {
    fetchTaskProgress();
  }, []);

  const fetchTaskProgress = async () => {
    try {
      const res = await request(BASEURL, TaskProgressQuery,{
        userId: ID
      });
      if (res.allProgressUpdates.success && res.allProgressUpdates.data) {
        const mappedData = res.allProgressUpdates.data.map((item) => ({
          id: item.id,
          assignedTo: `${item.task?.assignedTo?.username || ''} ${item.task?.assignedTo?.lastName || ''}`.trim(),
          title: item.task?.title || 'N/A',
          status: item.status || 'N/A',
          workCompleted: item.workCompleted ?? 'N/A',
          totalHoursSpent: item.totalHoursSpent ?? 'N/A',
          hoursWorked: item.hoursWorked ?? 'N/A',
          remainingTime: item.remainingTime ?? 'N/A',
        }));
        setRows(mappedData);
      }
    } catch (error) {
      console.error('Error fetching task progress:', error);
    }
  };

  const handleChangePage = (event, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
     <Paper sx={{ p: 2, borderRadius: 2, display: "flex", flexDirection: "column", boxShadow:"0px 0px 10px 0px #0000001A", mt:"20px" }}>
      <Typography sx={{ padding: 2, textAlign: 'left' }} variant="h6" fontWeight="bold" mb={2}>
        Task Progress
      </Typography>
      <Box sx={{ width: '100%', overflowX: 'auto' }}> 
      <TableContainer sx={{ backgroundColor: '#e3f2fd', borderRadius: 2, p: 2 }}>

        <Table style={{ margin: 0 }}>
          {/* Table Head */}
          <TableHead sx={{ backgroundColor: '#e3f2fd' }}>
            <TableRow>
              {[
                'Assigned To',
                'Task Title',    
                'Work Completed',
                'Total Hours',
                'Hours Worked',
                'Remaining Time',
                'Status',
              ].map((header) => (
                <TableCell
                  key={header}
                  sx={{
                    fontWeight: 'bold',
                    color: '#0d47a1',
                    fontSize: '1 rem',
                    whiteSpace: 'nowrap',
                  }}
                >
                  {header}
                </TableCell>
              ))}
            </TableRow>
               {/* Table Body */}
          <TableBody>
            {rows.length === 0 ? (
              <TableRow>
                <TableCell colSpan={7} align="center">
                  No Data Available
                </TableCell>
              </TableRow>
            ) : (
              rows
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row) => (
                    <TableRow
                    key={row.id}
                    hover
                    sx={{
                      '&:hover': {
                        backgroundColor: '#fefefe',
                      },
                    }}
                  >
                  
                    <TableCell sx={{ fontSize: '0.75rem' }}>{row.assignedTo}</TableCell>
                    <TableCell sx={{ fontSize: '0.75rem' }}>{row.title}</TableCell>
                    <TableCell sx={{ fontSize: '0.75rem' }}>{row.workCompleted}%</TableCell>
                    <TableCell sx={{ fontSize: '0.75rem' }}>{row.totalHoursSpent}</TableCell>
                    <TableCell sx={{ fontSize: '0.75rem' }}>{row.hoursWorked}</TableCell>
                    <TableCell sx={{ fontSize: '0.75rem' }}>{row.remainingTime}</TableCell>
                    <TableCell
                        sx={{
                            fontSize: '0.75rem',
                            color:
                            row.status.toLowerCase() === 'completed'
                                ? 'green'
                                : row.status.toLowerCase() === 'overdue'
                                ? 'red'
                                : 'gold',
                        }}
                        >
                        {row.status}
                    </TableCell>
                  </TableRow>
                ))
            )}
          </TableBody>
          </TableHead>

       
        </Table>
      </TableContainer>
      </Box>
      {/* Pagination */}
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          padding: '8px 16px',
          backgroundColor: '#f9f9f9',
        }}
      >
        <TablePagination
          rowsPerPageOptions={[10]}
          component="div"
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          ActionsComponent={({ count, page, rowsPerPage, onPageChange }) => (
            <Box sx={{ flexShrink: 0 }}>
              <IconButton
                onClick={(event) => onPageChange(event, page - 1)}
                disabled={page === 0}
              >
                <ChevronLeft />
              </IconButton>
              <IconButton
                onClick={(event) => onPageChange(event, page + 1)}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
              >
                <ChevronRight />
              </IconButton>
            </Box>
          )}
        />
      </Box>
    </Paper>
  );
};

export default TaskProgress;
